import { DISCLAIMERS_SUCCESS } from "../actions/constants";

export interface Disclaimers {
  mihm_disclaimer?: string;
  ihc_disclaimer?: string;
  digitization_disclaimer?: string;
}

const reducer = (
  state: Disclaimers | null = null,
  action: any
): Disclaimers | null => {
  switch (action.type) {
    case DISCLAIMERS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
